import React from 'react'
import styled from 'styled-components'

import { Link } from 'react-router-dom'

const Wrap = styled.footer`
  height: 6.5rem;
  padding: 0 20px;
  background-color: rgba(0, 0, 0, 0.3);
`

const Inside = styled.div`
  max-width: 1135px;
  margin: 0 auto;

  position: relative;
  top: 50%;
  transform: translateY(-50%);

  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Logo = styled(Link)`
  display: block;
  font-family: 'Source Sans Pro';
  font-size: 2rem;
  font-weight: bold;
  line-height: 2.5rem;
  color: #F2C94C;
  text-decoration: none;
  user-select: none;
`

const Navigation = styled.nav`
  display: block;
  text-align: right;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-weight: normal;
  line-height: 118%;
  color: #fff;
`

const Line = styled.hr`
  display:block;
  border: 0;
  clear:both;
  width: 96%;
  background-color:#FFFF00;
  height: 1px;
`

const NavigationItem = styled(Link)`
  ${props => props.margin && `
    margin-left: ${props.margin.left};
    margin-right: ${props.margin.right};
  `}

  ${props => props.bold && `
    font-weight: bold;
  `}
`

const Footer = (props) => (
  <Wrap>
    <Inside>
      <Logo to='/'>UABible</Logo>
      <Navigation>
        <NavigationItem to='#' onClick={() => window.scrollTo(0, 0)} margin={{left: '1rem', right: '1rem'}}>Back to top</NavigationItem>
      </Navigation>
    </Inside>
  </Wrap>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Landing/Footer.js